// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_5W0p7","middle":"middle_j0-ZD"};